'use client';

import Link from 'next/link';
import React from 'react';

import AllCasesCard from './AllCasesCard';
import MobileSlider from './MobileSlider';
import { CasesSliderProps } from './types';
import { ArticleCard } from '../../articleCard';
import { Button } from '../../button';
import { HalfPageSlider } from '../../halfPageSlider';

export const CasesSlider: React.FC<CasesSliderProps> = React.memo(
  ({
    articlesCards,
    title,
    link,
    linkText,
    allCasesCardText,
    allCasesButtonText = 'Посмотреть все',
    allCasesButtonTarget,
    allCasesBgData,
    halfPageSliderOverlayUrl,
    withoutAllCasesCard = false,
    slideHeight,
    renderWebCard,
    renderMobileCard,
  }) => {
    return (
      <>
        <div className="hidden max-lg:block">
          <h2 className="mb-[36px] px-4 text-[32px] leading-[38px] font-medium">
            {title}
          </h2>

          <div className="hidden grid-cols-1 gap-6 sm:grid-cols-2 lg:grid lg:grid-cols-3">
            {articlesCards.map((card, index) => (
              <div
                key={index}
                className={
                  'mr-0 ml-0 flex h-full w-full flex-col items-center justify-center hover:cursor-pointer hover:bg-linear-to-b'
                }
              >
                {renderWebCard ? (
                  renderWebCard(card)
                ) : (
                  <ArticleCard {...card} variant="article" />
                )}
              </div>
            ))}
          </div>
        </div>

        <HalfPageSlider
          leftContent={
            <div className="flex h-full flex-col items-start justify-center pt-9">
              <h2 className="mb-[64px] text-[44px] leading-[52px] font-medium">
                {title}
              </h2>

              <div className="flex">
                <Button
                  target={allCasesButtonTarget}
                  href="/cases"
                  variant="primary"
                  ariaLabel="Посмотреть все"
                  className="flex items-center justify-center px-6 py-4 max-sm:w-full"
                >
                  {allCasesButtonText}
                </Button>
              </div>
              {!!linkText && (
                <Link
                  href={link}
                  className="bg-custom-base-inverse-primary text-custom-base-primary hover:bg-custom-base-inverse-secondary flex h-[56px] w-fit cursor-pointer items-center justify-center rounded-xl px-6 transition-colors duration-300"
                >
                  {linkText}
                </Link>
              )}
            </div>
          }
          slides={[
            ...articlesCards.map((el) =>
              renderWebCard ? renderWebCard(el) : <ArticleCard {...el} />,
            ),
            !withoutAllCasesCard && (
              <AllCasesCard
                key="all-cases-card"
                link={link}
                text={allCasesCardText}
                bgData={allCasesBgData}
                target={allCasesButtonTarget}
              />
            ),
          ].filter(Boolean)}
          className="px-4 max-lg:hidden"
          overlayUrl={halfPageSliderOverlayUrl}
          slideHeight={slideHeight}
        />
        <MobileSlider
          articlesCards={articlesCards}
          allCasesCardProps={{
            link,
            text: allCasesCardText,
            bgData: allCasesBgData,
            target: allCasesButtonTarget,
          }}
          className="pl-4 lg:hidden"
          renderMobileCard={renderMobileCard}
        />
      </>
    );
  },
);
